import {TeacherDashboard} from './TeacherDashboard';

export default TeacherDashboard;
